import { Euler, Vector3 } from 'three';
import { SceneData } from '../../../atoms/scene';


const scenes_scenario_83: { [key: string]: SceneData } = {
	'scene_01': {
		camera_settings: {
			position: new Vector3(-1.9, 1.6, 3),
			target: new Vector3(-1.5, 1.5, 1)
		},

		objects: {
			'5': {
				type: 'character',
				position: new Vector3(-1.5, 0, 1.5),
				rotation: [0, -0.2, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},

			'3':{
				type: 'character',
				position: new Vector3(-0.1, 0, 0.5),
				rotation: [0, -0.8, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},
			'6':{
				type: 'character',
				position: new Vector3(1, -5, 0.5),
				rotation: [0, -1.2, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'15':{
				type: 'character',
				position: new Vector3(-0.4, -5, 0.7),
				rotation: [0, -0.8, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'10':{
				type: 'character',
				position: new Vector3(-2.8, 0, 2.9),
				rotation: [0, 32.8, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'4':{
				type: 'character',
				position: new Vector3(1.4, -5, 0.2),
				rotation: [0, -1.4, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'22':{
				type: 'character',
				position: new Vector3(1.4, -5, 0.2),
				rotation: [0, -1.4, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'12':{
				type: 'character',
				position: new Vector3(0.16, -0.4, -1.6),
				rotation: [0, -0.3, 0],
				sitting: true,
				idle: 'idle_sitting_lap',				
			},

			'13':{
				type: 'character',
				position: new Vector3(0.16, -5, -1.6),
				rotation: [0, -0.3, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			}

		},

		background_characters: [
			{	
				anim: 'idle_01',
				model: 'morgan',
				position: new Vector3(-2.5, -5, -1),
				rotation: new Euler(0,Math.PI / 1.1 ,0)
			},

			{	
				position: new Vector3(-1.2, -5, 3),
				rotation: new Euler(0,-1.5,0),
				model: 'chris',
				anim: 'talking_01'
			}
		],
	},

	'spirith_s2_2': {
		camera_settings: {
			position: new Vector3(-1.9, 1.6, 3),
			target: new Vector3(-1.5, 1.5, 1)
		},

		objects: {
			'5': {
				type: 'character',
				position: new Vector3(-1.7, 0, 1.5),
				rotation: [0, -0.2, 0],
				sitting: false,
				//idle: 'idle_sitting_desk',
			},
			'3':{
				type: 'character',
				position: new Vector3(-0.5, 0, 1.5),
				rotation: [0, -0.8, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},
			'4':{
				type: 'character',
				position: new Vector3(1.4, 0, 0.2),
				rotation: [0, -1.4, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'12':{
				type: 'character',
				position: new Vector3(0.16, -0.4, -1.6),
				rotation: [0, -0.3, 0],
				sitting: true,
				idle: 'idle_sitting_lap',				
			}
			
		},

	},

	'spirith_s2_3': {
		camera_settings: {
			position: new Vector3(-1.9, 1.6, 3),
			target: new Vector3(-1.5, 1.5, 1)
		},

		objects: {
			'3':{
				type: 'character',
				position: new Vector3(-1.5, 0, 1.5),
				rotation: [0, -0.2, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'6':{
				type: 'character',
				position: new Vector3(1, 0, 0.4),
				rotation: [0, -1.2, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'15':{
				type: 'character',
				position: new Vector3(-0, 0, 0.7),
				rotation: [0, -0.8, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'4':{
				type: 'character',
				position: new Vector3(-0.8, 0, 0.8),
				rotation: [0, -0.5, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'12':{
				type: 'character',
				position: new Vector3(0.16, -0.4, -1.6),
				rotation: [0, -0.3, 0],
				sitting: true,
				idle: 'idle_sitting_lap',				
			}

		},


		background_characters: [
			{	
				anim: 'taking_02',
				model: 'morgan',
				position: new Vector3(3.9, 0, -1),
				rotation: new Euler(0, -2 ,0)
			},

			{	
				position: new Vector3(2.5, 0, -1.),
				rotation: new Euler(0,1.5,0),
				model: 'chris',
				anim: 'talking_01'
			}
		],

	},

	'spirith_s2_4': {
		camera_settings: {
			position: new Vector3(-1.9, 1.6, 3),
			target: new Vector3(-1.5, 1.5, 1)
		},

		objects: {
			'6':{
				type: 'character',
				position: new Vector3(1, 0, 0.5),
				rotation: [0, -1.2, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'15':{
				type: 'character',
				position: new Vector3(-0.8, 0, 0.8),
				rotation: [0, -0.5, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'13':{
				type: 'character',
				position: new Vector3(-2.8, 0, 2.9),
				rotation: [0, 32.8, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'4':{
				type: 'character',
				position: new Vector3(-1.5, 0, 1.5),
				rotation: [0, -0.2, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			},

			'12':{
				type: 'character',
				position: new Vector3(0.16, -0.4, -1.6),
				rotation: [0, -0.3, 0],
				sitting: true,
				idle: 'idle_sitting_lap',				
			}

		},
	},

	'spirith_s2_5': {
	camera_settings: {
		position: new Vector3(-1.9, 1.6, 3),
		target: new Vector3(-1.5, 1.5, 1)
		},

		objects: {
			'13':{
				type: 'character',
				position: new Vector3(-2.8, 0, 2.9),
				rotation: [0, 32.8, 0],
				sitting: false,
				//idle: 'idle_sitting_lap',				
			}

		},

	},

};


export default scenes_scenario_83;

